// Indicador de versión (retro 2026-08-01): app nativa (APK/IPA) + build web.
// - "App": versión instalada del binario (requiere APK 1.4.1+; en versiones
//   viejas el plugin no existe y solo se muestra el build web).
// - "Web": sello del último deploy — cambia solo con cada publicación.
import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'

export function AppVersion({ className = '' }: { className?: string }) {
  const [native, setNative] = useState<string | null>(null)

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    import('@capacitor/app')
      .then(({ App }) => App.getInfo())
      .then((info) => setNative(`${info.version} (${info.build})`))
      .catch(() => setNative(null)) // APK viejo sin el plugin: solo build web
  }, [])

  return (
    <p className={`text-[11px] text-gray-400 ${className}`}>
      {native ? `App ${native} · ` : ''}Web {__WEB_BUILD__}
    </p>
  )
}
